import { Link } from '@remix-run/react';
import { buttonVariants } from '~/components/ui/button';
import { cn } from '~/lib/utils/shadcn';

interface Props {
  pedal: Pedal;
  amazonAssociateId?: string;
  rakutenAffiliateUrl?: string;
}

interface Pedal {
  name: string;
  brand: {
    name: string;
  };
}

export const AffiliateLinks = ({ pedal, amazonAssociateId, rakutenAffiliateUrl }: Props) => {
  const searchName = `${pedal.brand.name} ${pedal.name}`;
  const encodedSearchName = encodeURIComponent(searchName);
  // const amazonLink = `https://www.amazon.co.jp/gp/search/?ie=UTF8&field-keywords=${searchName}&tag=${amazonAssociateId}`;
  const amazonLink = amazonAssociateId ? `https://www.amazon.co.jp/gp/search/?field-keywords=${encodedSearchName}&tag=${amazonAssociateId}` : null;
  // const rakutenLink = `https://hb.afl.rakuten.co.jp/hgc/0ef3342d.a2ff6a7e.0f271d4c.f2cea173/?pc=https%3A%2F%2Fsearch.rakuten.co.jp%2Fsearch%2Fmall%2F${searchName}&link_type=text&ut=eyJwYWdlIjoidXJsIiwidHlwZSI6InRleHQiLCJjb2wiOjF9`;
  const rakutenLink = rakutenAffiliateUrl ? `${rakutenAffiliateUrl}/?pc=https%3A%2F%2Fsearch.rakuten.co.jp%2Fsearch%2Fmall%2F${encodedSearchName}` : null;

  return (
    <>
      <div className={'grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-3'}>
        {amazonLink && (
          <Link
            to={amazonLink}
            rel="nofollow noreferrer"
            target="_blank"
            className={cn(buttonVariants({ variant: 'outline' }), 'py-5 font-semibold border-[#FF9900] text-[#FF9900] hover:bg-[#FF9900] hover:text-white')}
          >
            Amazonで詳細・価格を見る
          </Link>
        )}
        {rakutenLink && (
          <Link
            to={rakutenLink}
            rel="nofollow noreferrer sponsored noopener"
            target="_blank"
            className={cn(buttonVariants({ variant: 'outline' }), 'py-5 font-semibold border-[#BD0000] text-[#BD0000] hover:bg-[#BD0000] hover:text-white')}
          >
            楽天市場で詳細・価格を見る
          </Link>
        )}
        { false && (
          <Link
            to={`https://www.soundhouse.co.jp/products/detail/item/264130/`}
            rel="nofollow noreferrer"
            target="_blank"
            className={cn(buttonVariants({ variant: 'outline' }), 'border-[#6b4374] text-[#6b4374] hover:bg-[#6b4374] hover:text-white')}
          >
            サウンドハウスで詳細・価格を見る
          </Link>
        )}
        { false && (
          <Link
            to={`https://shopping.yahoo.co.jp/search?p=${pedal.brand.name} ${pedal.name}`}
            rel="nofollow noreferrer"
            target="_blank"
            className={cn(buttonVariants({ variant: 'outline' }), 'border-cyan-500 text-cyan-500 hover:bg-cyan-500 hover:text-white')}
          >
            Yahoo!で詳細・価格を見る
          </Link>
        )}
        { false && (
          <Link
            to={`https://www.ishibashi.co.jp/ec/search/?SWD=${pedal.brand.name} ${pedal.name}`}
            rel="nofollow noreferrer"
            target="_blank"
            className={cn(buttonVariants({ variant: 'outline' }), 'border-rose-400 text-rose-400 hover:bg-rose-400 hover:text-white')}
          >
            イシバシ楽器で詳細・価格を見る
          </Link>
        )}
      </div>
    </>
  );
};